import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
// import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import HeroSection from "../components/HeroSection";
import Aboutillu from '../assets/images/homeabout.png';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import CountUp from "react-countup";
import { FireIcon, Cog6ToothIcon, BeakerIcon, WrenchScrewdriverIcon, PaintBrushIcon } from '@heroicons/react/24/solid';
import OurServices from "../components/OurServices";

import Indomim from "../assets/images/clientslogo/indomim.jpeg";
import Accuspirals from "../assets/images/clientslogo/accuspirals.jpeg";
import Srs from "../assets/images/clientslogo/srs tech.jpeg";
import yuken from "../assets/images/clientslogo/yuken.jpeg";
import Bosch from "../assets/images/clientslogo/bosch.jpeg";
import LucasTVS from "../assets/images/clientslogo/lucas-tvs.jpeg";
import Amphenol from "../assets/images/clientslogo/amphenol.jpeg";
import Leatherman from "../assets/images/clientslogo/leatherman.jpeg";
import TweezerMan from "../assets/images/clientslogo/tweezerman.jpeg";
import Eicher from "../assets/images/clientslogo/eicher.jpeg";


// ✅ Products Data
// const products = [
//   {
//     title: "Transformers",
//     description: "High-performance industrial transformers built for reliability.",
//     img: "https://via.placeholder.com/300x200?text=Transformer",
//   },
//   {
//     title: "Fabrication Works",
//     description: "Custom precision fabrication tailored to client requirements.",
//     img: "https://via.placeholder.com/300x200?text=Fabrication",
//   },
//   {
//     title: "Vacuum Ovens",
//     description: "Efficient and durable vacuum ovens for industrial use.",
//     img: "https://via.placeholder.com/300x200?text=Vacuum+Oven",
//   },
//   {
//     title: "Spray Painting Booths",
//     description: "Advanced spray painting booths ensuring high-quality finishes.",
//     img: "https://via.placeholder.com/300x200?text=Painting+Booth",
//   },
//   {
//     title: "Electrical Supplies",
//     description: "Wide range of electrical products and industrial solutions.",
//     img: "https://via.placeholder.com/300x200?text=Electrical+Supplies",
//   },
// ];

// // ✅ Core Values
// const values = [
//   { title: "Quality", desc: "We ensure world-class quality in every project we deliver." },
//   { title: "Innovation", desc: "Our solutions integrate the latest technologies & creativity." },
//   { title: "Sustainability", desc: "Eco-friendlyy practices for a better tomorrow." },
// ];

// ✅ Clients / Partners Logos
// ✅ Direct Clients Logos
const directClients = [
  {
    name: "Indo-MIM",
    logo: Indomim,
  },
  {
    name: "Accuspirals",
    logo: Accuspirals,
  },
  {
    name: "SRS Technologies",
    logo: Srs,
  },
  {
    name: "Yuken India Limited",
    logo: yuken,
  },
  // {
  //   name: "Arunodaya Manufacturing",
  //   logo: "https://www.arunodayamfg.com/logo.png",
  // },
];

// ✅ Indirect Clients Logos
const indirectClients = [
  {
    name: "Bosch",
    logo: Bosch,
  },
  {
    name: "Lucas-TVS",
    logo: LucasTVS,
  },
  {
    name: "Amphenol",
    logo: Amphenol,
  },
  {
    name: "Leatherman",
    logo: Leatherman,
  },
  {
    name: "Tweezer Man",
    logo: TweezerMan,
  },
  {
    name: "Eicher",
    logo: Eicher,
  },
];

// Duplicate automatically
const duplicatedDirect = [...directClients, ...directClients];
const duplicatedIndirect = [...indirectClients, ...indirectClients];



const Home: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate API loading
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full">
      <Helmet>
  <title>Shree Engineering | Technical, Manufacturing & Engineering Solutions</title>
  <meta name="description" content="Shree Engineering provides professional technical consultancy, engineering solutions, manufacturing, heat treatment, spray booth, vacuum oven, fabrication, panel board, electrical supplies, and more worldwide. Contact us today." />
  <meta name="keywords" content="Engineering, Technical Consultancy, Manufacturing, Heat Treatment, Spray Booth, Vacuum Oven, Fabrication, Panel Board, Electrical Supplies, Project Management, Automation, Shree Engineering" />

  {/* Open Graph */}
  <meta property="og:title" content="Shree Engineering | Technical, Manufacturing & Engineering Solutions" />
  <meta property="og:description" content="Providing professional technical consultancy, engineering solutions, manufacturing, heat treatment, spray booth, vacuum oven, fabrication, panel board, electrical supplies, and more worldwide." />
  <meta property="og:image" content="https://www.shree-eng.com/images/og-home.jpg" />
  <meta property="og:url" content="https://www.shree-eng.com" />
  <meta property="og:type" content="website" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Shree Engineering | Technical, Manufacturing & Engineering Solutions" />
  <meta name="twitter:description" content="Professional technical consultancy, engineering solutions, manufacturing, heat treatment, spray booth, vacuum oven, fabrication, panel board, electrical supplies, and more worldwide." />
  <meta name="twitter:image" content="https://www.shree-eng.com/images/og-home.jpg" />

  {/* Structured Data */}
  <script type="application/ld+json">
    {`
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Shree Engineering",
      "url": "https://www.shree-eng.com",
      "logo": "https://www.shree-eng.com/images/logo.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-XXXXXXXXXX",
        "contactType": "Customer Service",
        "email": "info@shree-eng.com"
      },
      "makesOffer": [
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Technical Consultancy"}},
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Engineering Solutions"}},
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Manufacturing"}},
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Heat Treatment"}},
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Spray Booth"}},
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Vacuum Oven"}},
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Fabrication"}},
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Panel Board"}},
        {"@type": "Offer","itemOffered":{"@type":"Service","name":"Electrical Supplies"}}
      ]
    }
    `}
  </script>
</Helmet>

      {/* Hero Section */}
      <HeroSection />

    {/* Engineering the Future Section */}
  <section className="relative py-20 px-4 md:px-20 bg-gradient-to-r from-blue-50 to-white overflow-hidden">
  {/* Background shapes */}
  <div className="absolute -top-10 -left-10 w-40 h-40 bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
  <div className="absolute -bottom-10 -right-10 w-60 h-60 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-bounce"></div>

  <motion.div
    className="max-w-6xl mx-auto text-center relative z-10"
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
  >
    <h2 className="text-4xl md:text-5xl font-extrabold text-blue-900 mb-6">
      Engineering the Future of <span className="text-orange-500">Metal Fabrication</span>
    </h2>

    <p className="text-base md:text-lg text-gray-700 mb-10 leading-relaxed">
      Welcome to <span className="font-semibold text-blue-900">Shree Engineering</span>, a leading force in advanced metal engineering solutions. 
      With state-of-the-art technologies and expert consultants, we deliver precision and innovation across:
    </p>

    {/* Features Grid */}
<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6 justify-items-center">
  {[
    { feature: "Heat Treatment", color: "text-orange-500", icon: FireIcon },
    { feature: "Metal Bending & Forming", color: "text-blue-500", icon: WrenchScrewdriverIcon },
    { feature: "Testing & Monitoring Labs", color: "text-green-500", icon: BeakerIcon },
    { feature: "Fabrication & Machining", color: "text-purple-500", icon: Cog6ToothIcon },
    { feature: "Advanced Ovens & Painting Booths", color: "text-red-500", icon: PaintBrushIcon },
  ].map((item, index) => (
    <motion.div
      key={index}
      className="bg-white rounded-lg shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2 flex flex-col items-center justify-center text-center w-28 sm:w-32 md:w-36 lg:w-40 aspect-square p-4"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.15 }}
      whileHover={{ scale: 1.05 }}
    >
      {/* Modern SVG Icon */}
      <item.icon className={`w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 ${item.color}`} />

      {/* Feature Text */}
      <p className="text-xs sm:text-sm md:text-sm lg:text-base mt-2 font-medium">
        {item.feature}
      </p>
    </motion.div>
  ))}
</div>
    <motion.p
      className="text-base md:text-lg mt-8 mb-6 text-gray-700 max-w-xl mx-auto"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 1.2 }}
    >
      Whether you're in <span className="font-semibold text-blue-900">aerospace, automotive, defense, energy, or industrial manufacturing</span>, 
      we provide engineered excellence from raw material to finished product.
    </motion.p>

    <motion.div
      initial={{ scale: 0.9, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 1.4 }}
    >
      <a
        href="/contact"
        className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 sm:px-8 rounded-lg shadow-lg transition transform hover:scale-105"
      >
        ➡ Partner with us
      </a>
    </motion.div>
  </motion.div>
</section>

      {/* Products Section */}
      {/* <section className="py-20 px-4 bg-gray-100">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          Our Products
        </h2>
        <p className="text-center text-gray-600 mb-12">
          Delivering engineering excellence through our range of products
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {loading
            ? Array(3)
                .fill(0)
                .map((_, index) => (
                  <div
                    key={index}
                    className="bg-white shadow-lg rounded-lg p-6 text-center"
                  >
                    <Skeleton height={200} className="mb-4" />
                    <Skeleton height={30} width={150} className="mb-2 mx-auto" />
                    <Skeleton count={2} />
                  </div>
                ))
            : products.map((product, index) => (
                <motion.div
                  key={index}
                  className="bg-white shadow-lg rounded-lg overflow-hidden"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                >
                  <img
                    src={product.img}
                    alt={product.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6 text-center">
                    <h3 className="text-xl font-semibold mb-2">
                      {product.title}
                    </h3>
                    <p className="text-gray-600">{product.description}</p>
                  </div>
                </motion.div>
              ))}
        </div>
      </section> */}

      {/* About Section */}
<section className="py-20 px-4 md:px-20 bg-blue-50 relative overflow-hidden">
  {/* Background circles for design */}
  <div className="absolute top-10 left-20 w-32 h-32 bg-blue-200 rounded-full opacity-20 animate-pulse" />
  <div className="absolute bottom-20 right-20 w-48 h-48 bg-orange-200 rounded-full opacity-20 animate-bounce" />

  <div className="md:flex md:items-center md:gap-10 max-w-6xl mx-auto relative z-10">
    {/* Left Image */}
    <motion.img
      src={Aboutillu}
      alt="About Us"
      className="w-full md:w-1/2 rounded-lg mb-8 md:mb-0 drop-shadow-lg"
      initial={{ opacity: 0, x: -100 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    />

    {/* Right Content with Counters */}
    <motion.div
      className="md:w-1/2"
      initial={{ opacity: 0, x: 100 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-900">
        About Shree Engineering
      </h2>
      <p className="text-gray-700 mb-4 leading-relaxed text-lg">
        Since <span className="font-semibold">2007</span>,{" "}
        <span className="font-semibold text-blue-900">Shree Engineering</span>{" "}
        has been a trusted name in the engineering and manufacturing sector. 
        With decades of expertise in{" "}
        <strong>
          fabrication, transformer manufacturing, vacuum ovens, spray painting
          booths, and electrical supplies
        </strong>
        , we provide precision-driven solutions for industries nationwide.
      </p>
      <p className="text-gray-700 mb-8 leading-relaxed text-lg">
        Our mission is to deliver high-quality engineering solutions that
        combine innovation, durability, and efficiency. We believe in building
        long-term partnerships with our clients, empowering industries to
        achieve more.
      </p>

      {/* Counters */}
      <div className="grid grid-cols-3 gap-6 text-center">
  <motion.div whileHover={{ scale: 1.05 }}>
    <p className="text-4xl font-bold text-blue-900">
      <CountUp end={18} duration={2} />+
    </p>
    <p className="text-gray-600 text-sm">Years Experience</p>
  </motion.div>

  <motion.div whileHover={{ scale: 1.05 }}>
    <p className="text-4xl font-bold text-blue-900">
      <CountUp end={500} duration={2} />+
    </p>
    <p className="text-gray-600 text-sm">Projects</p>
  </motion.div>

  <motion.div whileHover={{ scale: 1.05 }}>
    <p className="text-4xl font-bold text-blue-900">
      <CountUp end={100} duration={2} />+
    </p>
    <p className="text-gray-600 text-sm">Global Clients</p>
    </motion.div>
    </div>
    </motion.div>
  </div>
</section>

{/* Our Services Section */}
<OurServices />

      {/* Core Values Section */}
<section className="relative py-20 bg-gradient-to-b from-blue-50 to-white px-4 overflow-hidden">
  {/* Background accents */}
  <div className="absolute top-10 left-10 w-32 h-32 bg-orange-100 rounded-full blur-3xl opacity-30 animate-pulse -z-10"></div>
  <div className="absolute bottom-10 right-10 w-40 h-40 bg-blue-100 rounded-full blur-3xl opacity-30 animate-bounce -z-10"></div>

  <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
    Our Core Values
  </h2>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
    {[
      {
        title: "Quality",
        desc: "We ensure world-class quality in every project we deliver.",
        icon: "https://cdn-icons-png.flaticon.com/512/190/190411.png",
      },
      {
        title: "Innovation",
        desc: "Our solutions integrate the latest technologies & creativity.",
        icon: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      },
      {
        title: "Sustainability",
        desc: "Eco-friendly practices for a better tomorrow.",
        icon: "https://cdn-icons-png.flaticon.com/512/481/481874.png",
      },
    ].map((value, index) => (
      <motion.div
        key={index}
        className="bg-white p-8 rounded-xl shadow-lg text-center hover:shadow-2xl transition transform hover:-translate-y-2"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: index * 0.2 }}
      >
        <motion.img
          src={value.icon}
          alt={value.title}
          className="w-16 h-16 mx-auto mb-4"
          whileHover={{ rotate: 10, scale: 1.1 }}
          transition={{ type: "spring", stiffness: 200 }}
        />
        <h3 className="text-xl font-semibold text-blue-900 mb-2">
          {value.title}
        </h3>
        <p className="text-gray-600">{value.desc}</p>
      </motion.div>
    ))}
  </div>
</section>
{/* Clients / Partners Section */}
<section className="py-20 px-4 bg-gray-50 relative overflow-hidden">
  <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-200 rounded-full blur-3xl opacity-40 animate-pulse"></div>
  <div className="absolute -bottom-20 -right-20 w-72 h-72 bg-orange-200 rounded-full blur-3xl opacity-40 animate-pulse"></div>

  <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
    Our Clients & Partners
  </h2>

  <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="text-center text-gray-600 mb-12 max-w-2xl mx-auto relative z-10" > Trusted by global leaders for <span className="text-blue-900 font-semibold">innovation and excellence</span>. </motion.p>

  <div className="max-w-7xl mx-auto space-y-16 relative z-10">
    {/* Direct Clients */}
    <div>
      <h3 className="text-xl font-semibold text-center mb-6 text-blue-900">Direct Clients</h3>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={2}
        autoplay={{ delay: 0, disableOnInteraction: false }}
        speed={4000}
        loop={true}
        allowTouchMove={false}
        breakpoints={{
          640: { slidesPerView: 3 },
          1024: { slidesPerView: 6 },
        }}
      >
        {duplicatedDirect.map((client, index) => (
          <SwiperSlide key={index}>
            <div className="flex items-center justify-center">
              <motion.img
                src={client.logo}
                alt={client.name}
                className="h-16 w-auto object-contain grayscale hover:grayscale-0 transition duration-300"
                whileHover={{ scale: 1.1 }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>

    {/* Indirect Clients */}
    <div>
      <h3 className="text-xl font-semibold text-center mb-6 text-orange-600">Indirect Clients</h3>
      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={2}
        autoplay={{ delay: 0, disableOnInteraction: false, reverseDirection: true }}
        speed={4000}
        loop={true}
        allowTouchMove={false}
        breakpoints={{
          640: { slidesPerView: 3 },
          1024: { slidesPerView: 6 },
        }}
      >
        {duplicatedIndirect.map((client, index) => (
          <SwiperSlide key={index}>
            <div className="flex items-center justify-center">
              <motion.img
                src={client.logo}
                alt={client.name}
                className="h-16 w-auto object-contain grayscale hover:grayscale-0 transition duration-300"
                whileHover={{ scale: 1.1 }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </div>
</section>


            {/* Why Choose Us Section */}
      <section className="relative py-20 px-4 overflow-hidden">
        {/* Animated background shapes */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-10 left-10 w-40 h-40 bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-60 h-60 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-bounce"></div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
          Why Choose <span className="text-blue-900">Shree Engineering?</span>
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          We don’t just deliver products — we deliver trust, innovation, and
          long-term value for your business.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            {
              title: "Expertise & Experience",
              desc: "Decades of hands-on experience with complex engineering projects.",
              icon: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
            },
            {
              title: "Cutting-edge Technology",
              desc: "We use advanced tools and innovation to build reliable solutions.",
              icon: "https://cdn-icons-png.flaticon.com/512/1055/1055646.png",
            },
            {
              title: "Customer-Centric Approach",
              desc: "We focus on client satisfaction and tailor solutions for each need.",
              icon: "https://cdn-icons-png.flaticon.com/512/1087/1087840.png",
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition transform hover:-translate-y-2"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.3 }}
            >
              <motion.img
                src={item.icon}
                alt={item.title}
                className="w-16 h-16 mx-auto mb-4"
                whileHover={{ rotate: 10, scale: 1.1 }}
                transition={{ type: "spring", stiffness: 200 }}
              />
              <h3 className="text-xl font-semibold text-blue-900 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-600">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>
{/* Features Section */}
      <section className="relative py-20 px-6 bg-gray-50 overflow-hidden">
        {/* Background animation */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-16 right-16 w-40 h-40 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
          <div className="absolute bottom-10 left-10 w-60 h-60 bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-bounce"></div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
          Key <span className="text-blue-900">Features</span> of Shree Engineering
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
          From design to delivery, our engineering solutions stand out with 
          precision, reliability, and customer-focused innovation.
        </p>

        {/* 2 Highlights */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          {[
            { title: "100% Custom Solutions", desc: "Tailor-made engineering products designed for your unique needs.", icon: "https://cdn-icons-png.flaticon.com/512/679/679720.png" },
            { title: "End-to-End Support", desc: "We assist from concept, prototyping, to installation & maintenance.", icon: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png" },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="bg-white rounded-xl shadow-md p-8 text-center hover:shadow-xl transition"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.2 }}
            >
              <img src={item.icon} alt={item.title} className="w-14 h-14 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-blue-900 mb-2">{item.title}</h3>
              <p className="text-gray-600">{item.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* 3 Differentiators */}
        <h3 className="text-2xl font-bold text-center mb-8">What Makes Us Different?</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-16">
          {[
            { title: "Precision Engineering", desc: "High accuracy manufacturing with global standards.", icon: "https://cdn-icons-png.flaticon.com/512/1055/1055646.png" },
            { title: "Trusted by Industries", desc: "Serving clients across automotive, electrical & civil sectors.", icon: "https://cdn-icons-png.flaticon.com/512/809/809957.png" },
            { title: "Affordable Excellence", desc: "Top-quality products delivered at competitive pricing.", icon: "https://cdn-icons-png.flaticon.com/512/2920/2920349.png" },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-xl transition"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.2 }}
            >
              <img src={item.icon} alt={item.title} className="w-12 h-12 mx-auto mb-3" />
              <h4 className="text-lg font-semibold text-blue-900 mb-1">{item.title}</h4>
              <p className="text-gray-600">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Call to Action Section */}
      {/* <section className="py-20 px-4 text-center bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <motion.h2
          className="text-3xl md:text-4xl font-bold mb-6"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Ready to Work With Us?
        </motion.h2>
        <motion.p
          className="max-w-2xl mx-auto mb-8 text-lg text-blue-100"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Let’s build the future of engineering together. Contact us to discuss
          your project requirements today.
        </motion.p>
        <motion.a
          href="/contact"
          className="bg-white text-blue-700 font-semibold py-3 px-8 rounded-lg shadow hover:bg-gray-100 transition"
          initial={{ scale: 0.9 }}
          whileHover={{ scale: 1.05 }}
        >
          Contact Us
        </motion.a>
      </section> */}
    </div>
  );
};

export default Home;
